import './Logout.css';
import '../common-style.css';

import { OrRuler } from 't-lib-ui/structure';
import { useContext } from 'react';
import { goTo, RouterContext } from 't-lib-ui/router';
import { FlowForm, useFlowFormGlobal, FormGrid, FormGridLine } from 't-lib-ui/structure';
import { TextButton } from 't-lib-ui/widgets';
import DownreadLogo from '../../components/DownreadLogo';

// The logged-out confirmation card: explains why the session ended (the message varies by how the
// logout happened) and offers both ways forward — log in again or continue anonymously. Shared by
// the /logged-out page below and the /logout page's post-logout state. Callers own the FlowForm
// hooks (useFlowFormGlobal), so screens that render this conditionally don't double-register.
export const LoggedOutScreen: React.FC<{message: string}> = ({message}) => {
  const routerCtx = useContext(RouterContext);

  return (
    <FlowForm main={true}>
      <div className="authPage">
        <div className="authCard logoutCard">
          <div className="authLogo">
            <a href="https://downread.com" className="authLogoLink"><DownreadLogo size={48} showText /></a>
          </div>
          <div className="authIntro">{message}</div>

          <FormGrid>
            <FormGridLine span={2} align='center' className='logoutActionRow'>
              <TextButton label='Log in again' onClick={() => goTo(routerCtx, '/login', 'replace')} className='relogin' type='major'/>
            </FormGridLine>
          </FormGrid>

          <div className="authDivider"><OrRuler /></div>

          <FormGrid>
            <FormGridLine span={2} align='center' className='logoutActionRow'>
              <TextButton label='Continue in anonymous mode' type='minor' onClick={() => goTo(routerCtx, '/', 'replace')} className='logoutContinue' />
            </FormGridLine>
          </FormGrid>
        </div>
      </div>
    </FlowForm>
  );
};

// Shown in the OTHER tabs after a logout happened somewhere else (another tab of this browser —
// see auth-sync.ts and the listener in App.tsx). Landing these tabs on the anonymous start page
// confused users, so they land here instead.
const LoggedOut: React.FC = () => {
  useFlowFormGlobal();
  return <LoggedOutScreen message="You've been logged out in another tab or window, so this tab was logged out too." />;
};

export default LoggedOut;
